import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';

const SrUtilitySetupTransferInternetFlowReturnEquipmentModal = ({
  providerName,
  onSubmit,
  onClose,
}) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-point.png"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      innerStyle={{ maxWidth: '400px' }}
      maxIconHeight="100px"
      maxIconWidth="100px"
      onClose={onClose}
      headline={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="24px" weight="800" font="greycliff" display="block">
            One more thing.
          </SrText>
          <SrText fontSize="24px" weight="800" font="greycliff" display="block">
            Return your current modem to the store.
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox maxWidth="250px" margin="0 auto">
          <SrText font="greycliff" fontSize="16px" lineHeight="25px" weight="600" align="center">
            You will receive your new equipment at your new address. Be sure to return your old
            equipment to the local {providerName} store.
          </SrText>
        </SrBox>
      }
      srMultiButtons={[
        {
          buttonText: 'I understand',
          onButtonClick: onSubmit,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
      ]}
      showSubLabelDecoration={false}
      subLabelText={
        'By pressing “I understand” you acknowledge if you do not return your' +
        'equipment to the store, you will continue to get charged at your previous address.'
      }
    />
  );
};

SrUtilitySetupTransferInternetFlowReturnEquipmentModal.propTypes = {
  providerName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilitySetupTransferInternetFlowReturnEquipmentModal.displayName =
  'SrUtilitySetupTransferInternetFlowReturnEquipmentModal'; // eslint-disable-line max-len

export default SrUtilitySetupTransferInternetFlowReturnEquipmentModal;
